// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2qUFl","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2m3H8"};